module.exports = __webpack_public_path__ + "static/duftstoevchen_1.1a042321.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fulls/duftstoevchen_1.jpg
// module id = 547
// module chunks = 35783957827783